import styled from 'styled-components';

export const Fieldset = styled.fieldset`
  border: none;
  padding: 0;
  margin: 1rem 0;
  ${Styles.desktop`
      margin: 0 0 2rem 0;
  `}
`;

export const Legend = styled.legend`
  display: block;
  font-size: 1.2rem;
  text-align: center;
  font-weight: ${Styles.fontWeight.heavy};
  margin: 0 0 1rem 0;
`;
export const Container = styled.ul`
  display: flex;
  padding: 0;
  justify-content: center;

  & > :first-child label {
    border-radius: ${Styles.borderRadius} 0 0 ${Styles.borderRadius};
  }

  & > :last-child label {
    border-radius: 0 ${Styles.borderRadius} ${Styles.borderRadius} 0;
    border-right: 1px solid ${Styles.color.grey.three};
  }
`;

export const Label = styled.label<{ isSelected: boolean }>`
  display: block;
  border: 1px solid ${Styles.color.grey.three};
  border-right: none;
  color: ${Styles.color.black};
  font-size: 0.9375rem;
  font-weight: ${p => (p.isSelected ? Styles.fontWeight.heavy : Styles.fontWeight.normal)};
  padding: 0.75rem 0;
  text-align: center;
  cursor: pointer;

  :hover {
    background: ${Styles.color.black};
    color: ${Styles.color.white};
    border-color: ${Styles.color.black};
    z-index: ${Styles.zIndex.below};
  }
`;

export const Group = styled.li`
  flex: 1 0 auto;
  list-style: none;
  max-width: 70px;

  ${Styles.desktop`
    max-width: 140px;
  `}
`;

export const Radio = styled.input`
  position: absolute;
  left: -9999px;
  height: 1px;
  opacity: 0;
  font-family: ${Styles.fontFamily.base};

  :checked + label {
    background: ${Styles.color.black};
    color: ${Styles.color.white};
    border-color: ${Styles.color.black};
    z-index: ${Styles.zIndex.below};
  }

  :focus + label {
    outline: -webkit-focus-ring-color auto 5px;
    outline-color: -webkit-focus-ring-color;
    outline-style: auto;
    outline-width: 5px;
  }

  /* work around for Edge not supporting outline-style: auto */
  @supports (-ms-ime-align: auto) {
    :focus + label {
      outline-color: invert;
      outline-width: 3px;
      outline-style: dotted;
    }
  }
`;
